import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { GetCoveragesFailure, GetCoveragesRequest, GetCoveragesSuccess } from './actions';
import { GetCoveragesService } from './service';

@Injectable()
export class GetCoveragesEffects {
  private readonly actions$ = inject(Actions);
  private readonly getCoveragesService = inject(GetCoveragesService);

  getCoverages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetCoveragesRequest),
      switchMap(({ parameters }) =>
        this.getCoveragesService.getCoverages(parameters).pipe(
          map(data => GetCoveragesSuccess({ data })),
          catchError(error => of(GetCoveragesFailure({ error })))
        )
      )
    )
  );

}
